const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	DESCRIPTION_MAX_LENGTH: 1000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
		ACCESSORIES: {
			PAGE: 'accessories-page',
			LIMIT: 'accessories-limit',
			SEARCH: 'accessories-search',
			SORT: 'accessories-sort',
		},
		COMPONENTS: {
			PAGE: 'components-page',
			LIMIT: 'components-limit',
			SEARCH: 'components-search',
			SORT: 'components-sort',
		},
		USERS: {
			PAGE: 'users-page',
			LIMIT: 'users-limit',
			SEARCH: 'users-search',
			SORT: 'users-sort',
		},
	},
	AVAILABLE_FONT_FAMILIES: [
		'Roboto',
		'Open Sans',
		'Lato',
		'Montserrat',
		'Inter',
		'Poppins',
		'Oswald',
		'Raleway',
		'Nunito',
		'Noto Sans',
		'Rubik',
		'Work Sans',
		'PT Sans',
		'Ubuntu',
		'Playfair Display',
		'Merriweather',
	],
} as const;

export default APP_CONFIG;
